import { Icon } from "@iconify/react";
import React from "react";

import styles from "./toast-message.module.scss";

const ToastMessage = ({ icon, message, closeToast }) => {
  return (
    <div className={styles["toast-container"]}>
      <span className={styles["toast-icon"]}>
        {typeof icon === "string" ? (
          icon
        ) : (
          <Icon icon={icon} height={20} width={20} />
        )}
      </span>
      <span className={styles["toast-message"]}>{message}</span>
      {/* {closeToast && (
        <button className={styles["toast-close"]} onClick={closeToast}>
          <Icon icon="codex:cross" height={20} width={20} />
        </button>
      )} */}
    </div>
  );
};

export default ToastMessage;
